// extracted by mini-css-extract-plugin
export default {"paragraph":"TestimonialCompany_paragraph__j8lGh"};